<template>
  <div class="pause-bar-box">
    <!-- 会员老客-已开通&暂停订阅 -->
    <div v-if="isBuyPauseStatus" class="pause-bar-info">
      {{ buyPauseStatusDesc }}
      <span class="rule" @click="handlePauseInfoClick">{{ $t('FoodC_update_ZFGk_VVRa') }}</span>
    </div>
    <!-- 会员老客-未开通&暂停订阅 -->
    <div v-if="isNoBuyPausedStatus" class="pause-bar-info">
      {{ isNoBuyPausedDesc }}
      <span class="rule" @click="handlePauseInfoClick">{{ $t('FoodC_update_ZFGk_VVRa') }}</span>
    </div>
  </div>
</template>
<script>
import mixin from '@/page/member/mixins.js'

export default {
  mixins: [mixin],
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    pauseStartDate() {
      return this.membership?.pauseStartDate
    },
    brandName() {
      return this.membership?.brandName
    },
    buyPauseStatusDesc() {
      // 这个翻译，为了兼容老的暂停有{{tc}}翻译：components/pauseRulesPopup/index.vue， 特殊处理了下
      return this.$t('FoodC_pause_dEKK_qnxf', {
        date1: this.membership?.pauseStartDate,
        num: this.membership?.pauseMonths,
        date2: this.membership?.pauseAutoResumeDate,
        brand: this.brandName,
        money: this.membership?.renewPriceSplit?.display,
      })
    },
    isNoBuyPausedDesc() {
      return this.$t('FoodC_pause_tfPj_IAoM', {
        date: this.membership?.pauseAutoResumeDate,
        brand: this.brandName,
        money: this.membership?.renewPriceSplit?.display,
      })
    },
  },
  methods: {
    handlePauseInfoClick() {
      this.$router.push({
        path: '/member/pauseInfo',
        query: {
          nativeWebUIType: 1,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.pause-bar-box {
  margin: 20px;
  padding: 32px;
  background-color: #fff;
  border-radius: 40px;
  .pause-bar-info {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #0b0b0d;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 400;
    .rule {
      text-decoration: underline;
      font-family: DiDiSans-Pro-Bold;
      font-size: 28px;
      color: #0b0b0d;
      letter-spacing: 0;
      line-height: 40px;
      font-weight: 700;
    }
  }
}
</style>
